import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_CONFI_COST_RESET = 'POST_CONFI_COST_RESET';
export const POST_CONFI_COST_LOADING = 'POST_CONFI_COST_LOADING';
export const POST_CONFI_COST_SUCCESS = 'POST_CONFI_COST_SUCCESS';
export const POST_CONFI_COST_REJECT = 'POST_CONFI_COST_REJECT';

//* ACTIONS ------------------------------------------------
export const postConfiCostReset = () => ({ type: POST_CONFI_COST_RESET });
export const postConfiCostLoading = () => ({ type: POST_CONFI_COST_LOADING });
export const postConfiCostSuccess = (payload) => ({ type: POST_CONFI_COST_SUCCESS, payload });
export const postConfiCostReject = (payload) => ({ type: POST_CONFI_COST_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postConfiCostRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/Costs/web/AddCosts`, options);
};
